import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const approveCollaborationRequest = createApiThunk<void, { id: string; status: "approved" | "rejected" }>(
  "collaborationRequests/approveCollaborationRequest",
  async (data: { id: string; status: "approved" | "rejected" }, { extra: { teacherRepository } }) => {
    return teacherRepository!.approveCollaborationRequest(data);
  },
);

export const resetApproveCollaborationRequest = createAction("collaborationRequests/resetApproveCollaborationRequest");
